import { render } from "./ImageTextTBContent.vue?vue&type=template&id=438ec4c5&scoped=true"
import script from "./ImageTextTBContent.vue?vue&type=script&lang=js"
export * from "./ImageTextTBContent.vue?vue&type=script&lang=js"

import "./ImageTextTBContent.vue?vue&type=style&index=0&id=438ec4c5&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438ec4c5"]])

export default __exports__